/* ==================================================================
   North Shore Peptides — Announcement Bar rotation
   Crossfade carousel · autoplay · pause on hover/focus · a11y
   ================================================================== */
(function () {
  'use strict';

  function initBar(root) {
    if (!root || root.dataset.npInit === 'true') return;
    root.dataset.npInit = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('.np-annc__slide'));
    if (slides.length <= 1) return; // nothing to rotate

    var prevBtn = root.querySelector('.np-annc__nav--prev');
    var nextBtn = root.querySelector('.np-annc__nav--next');
    var autoplay = root.dataset.autoplay === 'true';
    var interval = Math.max(2000, parseInt(root.dataset.interval || '5000', 10));
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var index = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
    if (index < 0) index = 0;
    var timer = null;

    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === index);
        s.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
    }
    function go(dir) { show(index + dir); restart(); }
    function start() {
      if (!autoplay || reduceMotion) return;
      stop();
      timer = window.setInterval(function () { show(index + 1); }, interval);
    }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    show(index);
    start();
  }

  function initAll() {
    document.querySelectorAll('.np-annc').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.np-annc');
    if (el) { el.dataset.npInit = ''; initBar(el); }
  });
})();
